import React from "react";
import { connect } from "react-redux";
import "./style.scss";

import Input from "../../components/controls/Input";
import { calcDiffDate, formatDisplayName } from "../../helpers";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { fetch_conversation, change_recipient, update_to_read } from "../../redux/Conversations/actions";

class index extends React.Component {
  state = {
    searchText: "",
    filteredConversations: [],
    originalConversations: [], // Store conversations before search
    isSearching: false,
    selectedFromSearch: null, // Track recipient selected during search
  };

  componentDidMount() {
    this.setState({
      filteredConversations: this.props.conversations,
      originalConversations: this.props.conversations,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.conversations !== this.props.conversations) {
      if (this.state.isSearching) {
        // During search, update filtered results
        this.setState({ filteredConversations: this.props.conversations });
      } else {
        // Not searching, update both lists
        this.setState({
          filteredConversations: this.props.conversations,
          originalConversations: this.props.conversations,
        });
      }
    }
  }

  _handleOnChange = (e) => {
    const searchValue = e.target.value;

    if (searchValue) {
      // Starting a search - save original list if not already saved
      if (!this.state.isSearching) {
        this.setState({
          originalConversations: this.props.conversations,
        });
      }

      this.setState({
        [e.target.name]: searchValue,
        isSearching: true,
      });

      // Fetch filtered conversations
      this.props.fetch_conversation({
        page: 1,
        rowsPerPage: 1000,
        isActive: 1,
        searchText: searchValue,
      });
    } else {
      // Clearing search - restore original list
      this.setState({
        [e.target.name]: searchValue,
        isSearching: false,
        selectedFromSearch: null,
        filteredConversations: this.state.originalConversations,
      });

      this.props.fetch_conversation({
        page: 1,
        rowsPerPage: 1000,
      });
    }
  };

  _handleOnClickConversation = (sender) => {
    // Update recipient in Redux
    this.props.change_recipient({ recipient: sender });

    // Mark conversation as read
    this.props.update_to_read({ recipient: sender });

    // If clicked during search
    if (this.state.isSearching && this.state.searchText) {
      // Save the selected recipient
      this.setState({ selectedFromSearch: sender });

      // Merge: selected conversation + original list (without duplicates)
      const selectedConversation = this.props.conversations.find((c) => c.sender === sender);

      if (selectedConversation) {
        // Remove the selected from original list if exists, then add it to top
        const originalWithoutSelected = this.state.originalConversations.filter((c) => c.sender !== sender);

        const mergedList = [selectedConversation, ...originalWithoutSelected];

        this.setState({
          filteredConversations: mergedList,
          isSearching: false,
          searchText: "", // Clear search
        });
      }
    } else {
      // Normal click without search - just refresh
      this.props.fetch_conversation({
        page: 1,
        rowsPerPage: 1000,
      });
    }
  };

  render() {
    const { filteredConversations, searchText } = this.state;

    return (
      <div className="ut-sidebar ut-border" style={{ marginTop: "-1px" }}>
        <Input onChange={this._handleOnChange} name="searchText" value={searchText} leftIcon={faSearch} size="sm" inputStyle="pilled" placeholder="search..." />
        <div className="ut-conversation-list">
          {filteredConversations.length > 0 ? (
            filteredConversations.map((conversation) => {
              return <Conversation key={conversation.id + conversation.sender} currentRecipient={this.props.recipient} onClick={this._handleOnClickConversation} conversation={conversation} />;
            })
          ) : (
            <div className="ut-no-results" style={{ padding: "20px", textAlign: "center", color: "#999" }}>
              {this.state.isSearching ? "No conversations found" : "No conversations"}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  recipient: state.Conversation.recipient,
  conversations: state.Conversation.conversations,
});

export default connect(mapStateToProps, { fetch_conversation, change_recipient, update_to_read })(index);

function Conversation(props) {
  const { sender, timestamp, isUnread, content, contentType, fullName } = props.conversation;
  const isActive = props.currentRecipient === sender;

  return (
    <div onClick={() => props.onClick(sender)} className={`ut-conversation ${isUnread > 0 ? "ut-conversation-unread" : ""} ${isActive ? "ut-conversation-active" : ""}`}>
      <img src="https://img.icons8.com/color/100/000000/user-male-circle.png" alt="user-profile" className="ut-conversation-profile" />
      <div className="ut-conversation-user">
        <span className="ut-conversation-name" style={isActive ? { color: "#FFF" } : { color: "#000" }}>
          {formatDisplayName(fullName, sender)}
        </span>
        <span className="ut-conversation-hint ut-ellipsis" style={isActive ? { color: "#FFF" } : { color: "#000" }}>
          {contentType === "IMAGE" ? "Sent an image." : content}
        </span>
      </div>
      <div className="ut-conversation-timestamp">
        <span className="ut-info">
          <i>{calcDiffDate(timestamp)}</i>
        </span>
        <div className="ut-conversation-unread-count">
          {sender !== "udaya" && isUnread > 0 && (
            <div>
              <span>{isUnread}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
